import request from '@/utils/request'
// 登录接口
export function login(data) {
  return request({
    url: '/portal/login',
    method: 'post',
    data: data
  })
}
// 获取验证码接口
export function getCaptcha() {
  return request({
    url: '/portal/getcaptcha',
    method: 'get'
  })
}
// 退出登录接口
export function exitLogin(data) {
  return request({
    url: '/portal/logout',
    method: 'post',
    data: data
  })
}
// 获取左侧菜单
export function getMenu() {
  return request({
    url: '/common/menulist',
    method: 'post'
  })
}
// 获取左侧菜单-发票数量
export function getMenuNum() {
  return request({
    url: '/invoice/kpsq_sum',
    method: 'post'
  })
}

// 获账号权限列表接口
export function getAccountList(data) {
  return request({
    url: '/admin/list',
    method: 'post',
    data: data
  })
}
// 创建账号
export function getAddAccount(data) {
  return request({
    url: '/admin/create',
    method: 'post',
    data: data
  })
}
// 编辑账号
export function getEditAccount(data) {
  return request({
    url: '/admin/edit',
    method: 'post',
    data: data
  })
}
// 删除账号
export function getDelAccount(data) {
  return request({
    url: '/admin/del',
    method: 'post',
    data: data
  })
}
// 获权限组列表接口
export function getJurisdictionList() {
  return request({
    url: '/gadmin/list',
    method: 'post'
  })
}
// 获取权限详情列表
export function getJurisdictionDetails() {
  return request({
    url: '/permission/list',
    method: 'post'
  })
}
// 创建权限组提交
export function getAddJurisdiction(data) {
  return request({
    url: '/gadmin/create',
    method: 'post',
    data: data
  })
}
// 创建权限组名字的验证 地址 http://doc.pharmconverge.com/index.php?s=/22&page_id=528
export function checkJurisdictionName(data) {
  return request({
    url: '/gadmin/check_user_by_name',
    method: 'post',
    data: data
  })
}
// 删除权限组
export function getDelJurisdiction(data) {
  return request({
    url: '/gadmin/del',
    method: 'post',
    data: data
  })
}
// 编辑权限获取已有权限
export function getJurisdictionCheck(data) {
  return request({
    url: '/admin/get_admin_group',
    method: 'post',
    data: data
  })
}
// 编辑权限组提交
export function getEditJurisdiction(data) {
  return request({
    url: '/gadmin/edit',
    method: 'post',
    data: data
  })
}
// 修改密码
export function getEditPassword(data) {
  return request({
    url: '/admin/change_pwd',
    method: 'post',
    data: data
  })
}
// 认证审核
export function getDetailVerify(params) {
  return request({
    url: 'account/account_confirm_list',
    method: 'get',
    params: params
  })
}
// 查看单条明细
export function getExamineDetail(licenseType, comfirmKey, cayNo, rp, currentPage) {
  return request({
    url: 'account/account_confirm_record',
    method: 'get',
    params: {
      license_type: licenseType,
      cay_comfirm_key: comfirmKey === '3' ? '2' : comfirmKey,
      cay_no: cayNo,
      rp: rp,
      current_page: currentPage
    }
  })
}
// ukey审核
export function getUkeyVerify(data) {
  return request({
    url: 'account/account_confirm_edit',
    method: 'post',
    data: data
  })
}
// 审核tab数量
export function getVerifyAmount(data) {
  return request({
    url: 'account/account_confirm_list_total',
    method: 'post',
    data: data
  })
}
